export default "__VITE_ASSET__BJqBdM7S__"